import { FIELD_TYPES } from 'src/constants/Fields';

const recurrings = [
  {
    field: 'recurrings.id',
    minWidth: 100,
    type: FIELD_TYPES.number,
  },
  {
    field: 'recurrings.title',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.contact_first_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.contact_last_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.contact_company_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.contact_email',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.amount',
    minWidth: 150,
    type: FIELD_TYPES.money,
  },
  {
    field: 'recurrings.frequency',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.start_date',
    minWidth: 150,
    type: FIELD_TYPES.date,
  },
  {
    field: 'recurrings.next_date',
    minWidth: 150,
    type: FIELD_TYPES.date,
  },
  {
    field: 'recurrings.end_date',
    minWidth: 150,
    type: FIELD_TYPES.date,
    hide: true,
  },
  {
    field: 'recurrings.state',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.create_invoice',
    minWidth: 150,
    type: FIELD_TYPES.boolean,
  },
  {
    field: 'recurrings.create_payment',
    minWidth: 150,
    type: FIELD_TYPES.boolean,
  },
  {
    field: 'recurrings.send_invoice_by_email',
    minWidth: 150,
    type: FIELD_TYPES.boolean,
    hide: true,
  },
  {
    field: 'recurrings.source',
    minWidth: 150,
    type: FIELD_TYPES.string,
    hide: true,
  },
  {
    field: 'recurrings.payment_type',
    minWidth: 150,
    type: FIELD_TYPES.paymentType,
  },
  {
    field: 'recurrings.cc_expiration',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'recurrings.bank_account_id',
    minWidth: 150,
    type: FIELD_TYPES.organisationBankAccount,
  },
  {
    field: 'recurrings.payment_gateway_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.payment_info_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.last_invoice_status',
    minWidth: 150,
    type: FIELD_TYPES.string,
    hide: true,
  },
  {
    field: 'recurrings.last_payment_status',
    minWidth: 150,
    type: FIELD_TYPES.string,
    hide: true,
  },
  {
    field: 'recurrings.invoice_counter',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.payment_counter',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.invoice_failure_count',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.payment_failure_count',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.invoice_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'recurrings.payment_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
];

export default recurrings;
